import React from 'react';
import {render} from 'react-dom';
import {ProductConfigurator} from './widgets/product-configurator/views';
import {ProductConfiguratorImage} from './widgets/product-configurator-image/views';
import {
    ProductConfiguratorNameModal,
    ProductConfiguratorLoginModal,
} from './widgets/product-configurator-modal/views';
import {Map} from './widgets/map/views';
import {Provider} from 'react-redux';
import * as core from './core';
import {init as initProductConfigurator} from './widgets/product-configurator/actions';
import {
    init as initHalfPizzaConfigurator,
    selectPizza,
} from './widgets/half-pizza-configurator/actions';
import * as halfPizzaSelectors from './widgets/half-pizza-configurator/selectors';
import {ProductConfiguratorSubmit} from './widgets/product-configurator-submit/views';
import {FindMe} from './widgets/find-me/views';
import * as logger from './logger';
import {GestureHandling} from 'leaflet-gesture-handling';
import * as leaflet from 'leaflet';
import {
    HalfPizzaConfigurator,
    HalfPizzaConfiguratorImage,
} from './widgets/half-pizza-configurator/views';
import * as mapActions from './widgets/map/actions';
import {MenuConfigurator} from './widgets/menu-configurator/views';
import {init as initMenuConfigurator} from './widgets/menu-configurator/actions';

import * as productCustomization from './components/product-customization/index';

logger.init();
leaflet.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);

const appWidget = {
    halfPizzaConfigurator: ({container, options}) => {
        core.dispatch(initHalfPizzaConfigurator(options));
        core.dispatch(
            selectPizza(halfPizzaSelectors.selectSelectedPizzas(options))
        );
        render(
            <Provider store={core.store}>
                <HalfPizzaConfigurator />
            </Provider>,
            container
        );
        render(
            <Provider store={core.store}>
                <HalfPizzaConfiguratorImage />
            </Provider>,
            $('#half-pizza-configurator-image')[0]
        );
    },
    productConfigurator: ({container, options}) => {
        core.dispatch(initProductConfigurator(options));
        render(
            <Provider store={core.store}>
                <ProductConfigurator />
            </Provider>,
            container
        );
    },
    productConfiguratorImage: ({container}) => {
        render(
            <Provider store={core.store}>
                <ProductConfiguratorImage />
            </Provider>,
            container
        );
    },
    productConfiguratorNameModal: ({container, options}) => {
        render(
            <Provider store={core.store}>
                <ProductConfiguratorNameModal {...options} />
            </Provider>,
            container
        );
    },
    productConfiguratorLoginModal: ({container, options}) => {
        render(
            <Provider store={core.store}>
                <ProductConfiguratorLoginModal {...options} />
            </Provider>,
            container
        );
    },
    productConfiguratorSubmit: ({container, options}) => {
        render(
            <Provider store={core.store}>
                <ProductConfiguratorSubmit {...options} />
            </Provider>,
            container
        );
    },
    map: ({container, options}) => {
        render(
            <Provider store={core.store}>
                <Map {...options} />
            </Provider>,
            container
        );
    },
    findMe: ({container, options}) => {
        render(
            <Provider store={core.store}>
                <FindMe {...options} />
            </Provider>,
            container
        );
    },
    paymentIframe: ({container}) => {
        const getHref = function () {
            try {
                return container.contentWindow.location.href;
            } catch (e) {}
        };

        const onLoad = function () {
            const href = getHref();
            if (href == null) {
                return;
            }

            const url = new URL(href);
            const redirectUrl = url.searchParams.get('app_redirect');
            if (redirectUrl == null) {
                return;
            }

            window.location.href = redirectUrl;
        };
        container.onload = onLoad;
        onLoad();
    },
    menuConfigurator: ({container, state}) => {
        core.dispatch(initMenuConfigurator(state));
        render(
            <Provider store={core.store}>
                <MenuConfigurator {...state} />
            </Provider>,
            container
        );
    },
    productCustomization: ({container, options}) => {
        const {ProductView, ConfiguratorPanel, init} = productCustomization;
        core.dispatch(init(options));
        render(
            <Provider store={core.store}>
                <ProductView />
                <ConfiguratorPanel />
            </Provider>,
            container
        );
    }
};

/*
 * `ready` prevents attaching sylius dom listeners
 * to the elements of the widgets
 */
$(document).ready(function () {
    $(document).on('click', '[data-trigger-event]', function(e) {
        $($(e.currentTarget).data('event-target') || e.currentTarget).trigger($(e.currentTarget).data('trigger-event'));
    });
    $(document).on('app-widget', '[data-app-widget-url]', function(e) {
        const url = $(e.currentTarget).data('app-widget-url');
        const container = $(e.currentTarget).data('container')
            ? $($(e.currentTarget).data('container'))[0]
            : e.currentTarget;
        $.ajax({
            type: 'GET',
            url: url,
            headers: { 'Accept': 'image/webp,*/*' },
        }).then((response) => {
            if (response.widget) {
                appWidget[response.widget]({container, state: response.state});
            } else {
                throw new Error('response.widget is a must');
            }
        });
    });
    $('[data-app-widget]').each(function (i, el) {
        const $el = $(el);

        const name = $el.data('app-widget');
        const options = $el.data('app-widget-options');

        appWidget[name]({
            container: el,
            options: options,
        });
    });

    $('[data-map-toggle]').click(function (e) {
        const mapId = $(this).data('map-toggle');
        core.store.dispatch(mapActions.toggle(mapId));
    });
});

document.querySelector('body').setAttribute('js-loaded', '');
